import React from 'react'
import { FormModal, FormInput, SelectPaymentOptions } from '../../../../onestep-library/BaseUI'
import { isThisANumber } from '../../../../onestep-library/Validators'
import { moneyize } from '../../../../onestep-library/TextPresenters/moneyize'
import { useSelector, useDispatch } from 'react-redux'
import { updateAddBalanceField, submitAddBalanceForm } from './actions'
import { injectStripe } from 'react-stripe-elements'
import {buildOptions, getCurrentTimeWithCurrentTimezone} from '../../../../../../utils'
import {uniq} from "lodash";

function AddBalanceForm(props){
  const dispatch = useDispatch()
  const { addBalanceForm, organization, resident, paymentSources } = useSelector(state=>state)
  const { balance } = useSelector(state=>state.account)
  const { ui, errors, memo, amount, payment_source, receipt_email } = addBalanceForm
  const { show, is_submitting } = ui
  const updateAddBalanceFieldAction = (payload) => dispatch(updateAddBalanceField(payload))
  const [emailRecipient, setEmailRecipient] = React.useState(false);
  const paySimplePMTRef = React.useRef();
  const [paySimpleCardValid, setPaySimpleCardValid] = React.useState(true);

  const emailOptions = buildOptions(
    uniq([paymentSources.email, resident.email])
  );

  const receiptEmailValue = emailOptions.find(
    (option) => option.value === receipt_email
  );

  function onClose(){
    dispatch({type: 'RESET_ADD_BALANCE_FORM'})
  }

  function onValidateRequiredFields(){
    return (
      amount.length > 0 &&
      memo.length > 0 && 
      !!payment_source && (
        (emailRecipient ? !!receipt_email : true) &&
        (payment_source.kind === 'other_card' ? paySimpleCardValid : true)
      )
    )
  }

  function onSubmit(){
    dispatch({type: 'BEGIN_SUBMIT_ADD_BALANCE'})
    if (payment_source.kind === 'other_card') {
      createNewPaymentSource()
    } else {
      dispatch(submitAddBalanceForm(addBalanceForm))
    }
  }

  function onErrors(){
    return(
      !isThisANumber(amount)
    )
  }

  function createNewPaymentSource(){
    if (organization.payment_processor === "paysimple") {
      paySimplePMTRef.current.submit();
    } else {
      createNewStripePaymentSource();
    }
  }

  function createNewPaySimplePaymentSource(paySimple){
    $.ajax({
      url: `/organizations/${organization.name}/residents/${resident.id}/payment_sources/create_pay_simple_card.json`,
      method: "POST",
      data: {
        payment_source: {
          kind: "card",
          pay_simple_token_id: paySimple.payment_method_token,
        },
      },
      success: (payment_source) => {
        addBalanceWithSource(payment_source);
      },
      error: (xhr) => {
        const errors = $.parseJSON(xhr.responseText).errors;
        dispatch({ type: "FAILED_SUBMIT_ADD_BALANCE", payload: errors });
      },
    });
  }

  function createNewStripePaymentSource(){
    props.stripe.createToken({name: 'Name'}).then(stripeResponse=>{
      if (stripeResponse.error) {
        dispatch({type: 'FAILED_SUBMIT_ADD_BALANCE', payload: [stripeResponse.error.message]})
        return false
      } else {
        $.ajax({
          url: `/organizations/${organization.name}/residents/${resident.id}/payment_sources.json`,
          method: 'POST',
          data: {
            payment_source: {
              kind: 'card',
              stripe_token_id: stripeResponse.token.id,
              stripe_source_id: stripeResponse.token.card.id,
              last4: stripeResponse.token.card.last4,
              brand: stripeResponse.token.card.brand,
            }
          },
          success: (payment_source) => {
            addBalanceWithSource(payment_source);
          },
          error: xhr => {
            const response = $.parseJSON(xhr.responseText);
            const errors = response.errors;
            const otherErrors = response.base ? response.base.join(', ') : null;
            dispatch({
              type: 'FAILED_SUBMIT_ADD_BALANCE',
              payload: [errors, otherErrors].filter(n => n)
            })
          }
        });
      }
    })
  }

  function addBalanceWithSource(payment_source) {
    dispatch({type: 'ADD_PAYMENT_SOURCE', payload: payment_source})
    dispatch(updateAddBalanceFieldAction({payment_source}))
    dispatch(submitAddBalanceForm())
    const nowWithTimezone = getCurrentTimeWithCurrentTimezone();
    dispatch({ type: "UPDATE_RESIDENT_UPDATED_AT",
      payload: { resident_updated_at: nowWithTimezone }});

  }

  return(
    <FormModal
      show={show}
      title="Add Balance"
      rightTitleLabel={`Current Balance: ${moneyize(balance)}`}
      isSubmitting={is_submitting}
      submitButtonLabel="Add Balance"
      errors={errors}
      handleClose={onClose} 
      handleValidateRequiredFields={onValidateRequiredFields}
      handleSubmit={onSubmit}
      handleErrors={onErrors}>
      <SelectPaymentOptions
        value={payment_source}
        hasCashOption
        hasCheckOption
        hasExternalOptions
        hasOtherOption
        hasOtherCardOption
        hasBalanceOption={false}
        showNewPaymentMethodButton={false}
        handlePaymentSourceChange={(payment_source)=>updateAddBalanceFieldAction({payment_source})}/>
      {
        payment_source && payment_source.kind === 'other_card' && (
          <>
            {organization.payment_processor === "paysimple" && (
              <FormInput
                ref={paySimplePMTRef}
                setCardValidation={(bool) => setPaySimpleCardValid(bool)}
                handlePaymentMethodSucceeded={createNewPaySimplePaymentSource}
                dispatchTypePaymentMethodFailed='FAILED_SUBMIT_ADD_BALANCE'
                labelClassName="font-weight-bold"
                type="credit_card_paysimple"
              />
            )}
            {organization.payment_processor === "stripe" && (
              <FormInput type="credit_card_stripe" />
            )}
          </>
        )
      }
      <FormInput
        type="money"
        label="Amount"
        handleChange={(amount)=>updateAddBalanceFieldAction({amount})}
        value={amount}/>
      <FormInput
        label="Memo"
        handleChange={(memo)=>updateAddBalanceFieldAction({memo})}
        value={memo}/>
      <FormInput
        label={"Would you like to email the client a receipt?"}
        labelClassName="font-weight-bold"
        type="select"
        placeholder="Yes or No?.."
        options={[
          { label: "Yes", value: "yes" },
          { label: "No", value: "no" },
        ]}
        handleChange={(e) => setEmailRecipient(e.value === 'yes')}
      />
      {emailRecipient && <FormInput
        type="select"
        isCreatable
        label={'Enter email address'}
        labelClassName="font-weight-bold"
        placeholder="example@me.com"
        value={receiptEmailValue}
        options={emailOptions}
        handleChange={(email) =>
          updateAddBalanceFieldAction({ receipt_email: email.value })
        }
      />}
    </FormModal>
  )
}

export default injectStripe(AddBalanceForm)